import { useState, useContext } from "react";
import axios from "../../../axios";
import { AuthContext } from "../../../context/AuthContext";

export default function RegisterForm({ onSuccess, onSwitchToLogin }) {
    const { setUser } = useContext(AuthContext);
    const [form, setForm] = useState({ name: "", phone: "", password: "" });
    const [error, setError] = useState("");

    const handleRegister = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const res = await axios.post("/register", form);
            setUser(res.data.user);
            localStorage.setItem("token", res.data.token);
            if (onSuccess) onSuccess();
        } catch (err) {
            console.error("Register error:", err);
            setError("Registrasi gagal. Pastikan data valid dan nomor belum terdaftar.");
        }
    };

    return (
        <div className="mt-3">
            <p>Daftar akun baru:</p>
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleRegister} className="mb-3">
                <input
                    className="form-control mb-2"
                    placeholder="Nama Lengkap"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
                <input
                    className="form-control mb-2"
                    placeholder="Nomor HP"
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
                <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Password"
                    value={form.password}
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                />
                <button type="submit" className="btn btn-success w-100">Daftar</button>
            </form>

            <p className="text-center mt-2">
                Sudah punya akun?{" "}
                <button type="button" className=" p-0" onClick={onSwitchToLogin}>
                    Login
                </button>
            </p>
        </div>
    );
}
